import React from 'react';
import { ReservationFlagTypeEnum } from '@api/ringil-api.v2';
import SvgFastForwardInverted from '@icons/fast-forward-inverted.svg?react';
import SvgGoodsReturn from '@icons/goods-return.svg?react';
import SvgBill from '@icons/bill.svg?react';

interface FlagIconProps {
  type: ReservationFlagTypeEnum;
  className?: string;
}

export const FlagIcon: React.FC<FlagIconProps> = ({ type, className }) => {
  switch (type) {
    case ReservationFlagTypeEnum.CROSS_DOCK:
      return <SvgFastForwardInverted className={className} />;
    case ReservationFlagTypeEnum.RETURNABLE_PACKAGE:
      return <SvgGoodsReturn className={className} />;
    case ReservationFlagTypeEnum.CUSTOMS:
      return <SvgBill className={className} />;
    default:
      return null;
  }
};

const FLAG_ORDER = Object.values(ReservationFlagTypeEnum);
const flagOrderIndex = (type: ReservationFlagTypeEnum) => {
  const idx = FLAG_ORDER.indexOf(type);
  return idx === -1 ? FLAG_ORDER.length : idx;
};

export const sortFlags = <T extends { reservationFlagType: ReservationFlagTypeEnum }>(flags: T[]): T[] =>
  [...flags].sort((a, b) => flagOrderIndex(a.reservationFlagType) - flagOrderIndex(b.reservationFlagType));